import React, { useState } from "react";

// const leaveHistory = [
//   {
//     id: 1,
//     name: "Rahul Sharma",
//     totalAllowed: { casual: 12, medical: 8 },
//     records: [
//       { type: "Casual", date: "2025-01-05", duration: 1, status: "Approved" },
//       { type: "Medical", date: "2025-01-12", duration: 2, status: "Pending" },
//       { type: "Absent", date: "2025-01-20", duration: 1, status: "Rejected" },
//       { type: "Casual", date: "2025-02-02", duration: 1, status: "Approved" },
//     ],
//   },
//   {
//     id: 2,
//     name: "Priya Verma",
//     totalAllowed: { casual: 10, medical: 6 },
//     records: [
//       { type: "Casual", date: "2025-01-03", duration: 2, status: "Approved" },
//       { type: "Absent", date: "2025-01-13", duration: 1, status: "Rejected" },
//     ],
//   },
// ];

const months = [
  "January","February","March","April","May","June",
  "July","August","September","October","November","December"
];

const currentMonth = months[new Date().getMonth()];

const LeaveReports = () => {
  const [selectedEmployee, setSelectedEmployee] = useState(leaveHistory[0].id);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const employee = leaveHistory.find(
    (e) => e.id === Number(selectedEmployee)
  );

  const monthFilteredRecords = employee.records.filter((r) => {
    const recordMonth = new Date(r.date).toLocaleString("default", {
      month: "long",
    });
    return recordMonth === selectedMonth;
  });

  const casualUsed = employee.records
    .filter((r) => r.type === "Casual" && r.status === "Approved")
    .reduce((sum, r) => sum + r.duration, 0);

  const medicalUsed = employee.records
    .filter((r) => r.type === "Medical" && r.status === "Approved")
    .reduce((sum, r) => sum + r.duration, 0);

  const totalLeavesUsed = casualUsed + medicalUsed;

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-6">Employee Leave History</h2>
      <div className="flex flex-wrap gap-4 mb-6">
        <select
          className="border px-3 py-2 rounded w-full sm:w-64"
          value={selectedEmployee}
          onChange={(e) => setSelectedEmployee(e.target.value)}
        >
          {leaveHistory.map((emp) => (
            <option key={emp.id} value={emp.id}>
              {emp.name}
            </option>
          ))}
        </select>

        <select
          className="border px-3 py-2 rounded w-full sm:w-48"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(e.target.value)}
        >
          {months.map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto mb-6">
        <table className="min-w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left">Type</th>
              <th className="px-4 py-3 text-left">Date</th>
              <th className="px-4 py-3 text-left">Duration</th>
              <th className="px-4 py-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {monthFilteredRecords.map((r, index) => (
              <tr key={index} className="border-t">
                <td className="px-4 py-3">{r.type}</td>
                <td className="px-4 py-3">{r.date}</td>
                <td className="px-4 py-3">{r.duration}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-1 rounded text-xs
                    ${r.status === "Approved" && "bg-green-100 text-green-600"}
                    ${r.status === "Rejected" && "bg-red-100 text-red-600"}
                    ${r.status === "Pending" && "bg-yellow-100 text-yellow-600"}
                  `}>
                    {r.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        <div className="bg-indigo-50 p-5 rounded-lg shadow">
          <h4 className="font-semibold">Total Leaves</h4>
          <p className="text-xl font-bold">
            {totalLeavesUsed} / {employee.totalAllowed.casual + employee.totalAllowed.medical}
          </p>
        </div>

        <div className="bg-green-50 p-5 rounded-lg shadow">
          <h4 className="font-semibold">Casual Leave</h4>
          <p className="text-xl font-bold">
            {casualUsed} / {employee.totalAllowed.casual}
          </p>
        </div>

        <div className="bg-blue-50 p-5 rounded-lg shadow">
          <h4 className="font-semibold">Medical Leave</h4>
          <p className="text-xl font-bold">
            {medicalUsed} / {employee.totalAllowed.medical}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LeaveReports;
